import React from 'react';
import { useSelector } from 'react-redux';

import * as S from '../../HotelSearchStyle';
import { FilterWrapper } from './FilterStyles';
import Button from 'common/Button/Button';
import { GenericP } from 'common/Styles';
import { formatTrackingMiceValue, trackMiceClick } from 'UtilityComponents/miceUtils';
import BottomRadioField from '../BottomFilter/BottomRadioField';
import { destinationSearchFilters } from '../../../../config';
import MiceDropDown from './miceDropDown';

const Filters = ({ searchResults, isMobile }) => {
	const searchFilterData = useSelector((state) => state.mice.searchFilterData);

	const handleSubmit = (e) => {
		e.preventDefault();
		const params = {};
		destinationSearchFilters.forEach((flt) => {
			if (flt.value) {
				params[flt.key] = flt.value.urlDataKey;
			}
		});

		searchResults(params);
		const trackVal = formatTrackingMiceValue({ ...params, ...searchFilterData });
		trackMiceClick(trackVal);
	};

	return (
		<S.FilterSection>
			{destinationSearchFilters && destinationSearchFilters.map((item) => {
				const { key, label } = item;
				if (key === 'eventType') {
					return (
						<FilterWrapper key={key}>
							<MiceDropDown
								field={item}
								value={searchFilterData[key]}
							/>
						</FilterWrapper>
					);
				} else {
					return (
						<>
							<FilterWrapper key={key}>
								<GenericP left_M='2' fsize='16px' f_weight='400' color='#000'>{label}</GenericP>
								<BottomRadioField value={searchFilterData[key]} field={item} isMobile={isMobile} />
							</FilterWrapper>

						</>
					);
				}
			})}
			<Button
				btnTxt='EXPLORE'
				btnType='Capsule'
				btnName='Primary'
				btnShadow
				btnWidth='192px'
				handleClick={handleSubmit}
			/>
		</S.FilterSection>
	);
};

export default Filters;
